
__webpack_require__.initializeExposesData = {
  moduleMap: {
  "./app": () => {
return __webpack_require__.e(/*  | __federation_expose_app */ "7194").then(() => (() => (__webpack_require__(82472))));
},
"./control-table": () => {
return Promise.all(/*  | __federation_expose_control_table */ [__webpack_require__.e("2964"), __webpack_require__.e("4990"), __webpack_require__.e("4427"), __webpack_require__.e("6209"), __webpack_require__.e("67")]).then(() => (() => (__webpack_require__(30231))));
},
"./control-rhp": () => {
return Promise.all(/*  | __federation_expose_control_rhp */ [__webpack_require__.e("2964"), __webpack_require__.e("4990"), __webpack_require__.e("4427"), __webpack_require__.e("6209"), __webpack_require__.e("2190"), __webpack_require__.e("1091"), __webpack_require__.e("8695")]).then(() => (() => (__webpack_require__(1792))));
},
"./control-dialog": () => {
return Promise.all(/*  | __federation_expose_control_dialog */ [__webpack_require__.e("2964"), __webpack_require__.e("4990"), __webpack_require__.e("4427"), __webpack_require__.e("6209"), __webpack_require__.e("2190"), __webpack_require__.e("2262")]).then(() => (() => (__webpack_require__(60916))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };